import styled from "styled-components";

const ProductCardWrapper = styled.div`
  .check-card {
    list-style: none;
    cursor: pointer;
    margin: 8px 0;

    .check-card-item {
      position: relative;
      width: 100%;
      // margin: 0 1% 15px;
      font-size: 16px;
      background: #fff;
      overflow: hidden;

      .home-insurance-max-limit {
        font-size: 12px;
        position: absolute;
        bottom: 0px;
        padding-inline-start: 15%;
        padding-inline-end: 15%;
        text-align: start;
        width: max-content;
      }

      label {
        display: block;
        position: absolute;
        height: 220px;
        width: 100%;
        z-index: 100;
        cursor: pointer;
      }

      .check-card-body {
        color: #6b47f5;
        border: 1px solid #6b47f5;
        border-radius: 5px;
        z-index: 2;
        position: relative;

        .check-card-body-in {
          padding: 12px 12px 48px 12px !important;
          display: flex;
          flex-direction: column;
          height: 320px;
          justify-content: space-between;
        }

        .check-card-title {
          font-family: "Bliss2", sans-serif;
          font-size: 16px;
          margin-bottom: 5px;
          font-weight: 800;
          text-align: center;
          text-transform: capitalize;
          user-select: none;
        }
        .check-card-icon {
          fill: #6b47f5;
          height: 40px;
          width: 40px;
          margin-bottom: 5px;
          user-select: none;
        }
        .check-card-icon-stc {
          fill: #4f008c;
          height: 40px;
          width: 40px;
          margin-bottom: 5px;
          user-select: none;
        }
        .check-card-description {
          font-size: 0.8rem;
          min-height: 24px;
          user-select: none;
        }
        &.disabled {
          color: #d3d3d3;
          border: 1px solid #d3d3d3;
          .check-card-icon {
            fill: #d3d3d3;
          }
        }
        .p-button {
          background-color: #d9dce1;
          border-color: #d9dce1;
          color: #4c565c;

          &:hover {
            background-color: #d4dbe7;
            box-shadow: none;
          }
          &:focus {
            box-shadow: none;
          }
        }
      }
      .check-card-body-stc {
        color: #4f008c;
        border: 1px solid #4f008c;
      }
    }
  }

  .check-card .check-card-bg,
  .check-card .check-card-toggle {
    position: relative;
    background: #2e2d37;
    width: 36px;
    height: 36px;
    top: 10px;
    left: 10px;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }
  .check-card .check-card-bg {
    position: absolute;
    background: #fff;
    color: #6b47f5;
    -webkit-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
    -webkit-transform: scale(1);
    transform: scale(1);
    z-index: 0;
  }
  .check-card .check-card-toggle span {
    position: absolute;
    display: block;
    width: 20px;
    margin-left: -10px;
    height: 1px;
    top: 50%;
    left: 50%;
    background: #fff;
    -webkit-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;

    -webkit-transform: rotate(-270deg);
    transform: rotate(-270deg);
  }
  .check-card .check-card-toggle span:first-child {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  .check-card input[type="checkbox"] {
    display: none;
  }
  .check-card input[type="checkbox"]:checked ~ .check-card-body {
    background: #6b47f5;
    border-color: #6b47f5;
    color: #fff;
  }
  .check-card input[type="checkbox"]:checked ~ .check-card-body-stc {
    background: #4f008c;
    border-color: #4f008c;
    color: #fff;
  }
  .check-card
    input[type="checkbox"]:checked
    ~ .check-card-body
    .check-card-icon {
    fill: #6b47f5;
  }
  .check-card
    input[type="checkbox"]:checked
    ~ .check-card-body-stc
    .check-card-icon {
    fill: #4f008c;
  }

  .check-card
    input[type="checkbox"]:checked
    ~ .check-card-body
    .check-card-icon
    path {
    fill: #fff;
  }
  .check-card input[type="checkbox"]:checked ~ .check-card-body .p-button {
    background-color: #fff;
    color: #6b47f5;
    border-color: #fff;
  }
  .check-card input[type="checkbox"]:checked ~ .check-card-body-stc .p-button {
    background-color: #fff;
    color: #4f008c;
    border-color: #fff;
  }
  .check-card
    input[type="checkbox"]:checked
    ~ .check-card-body
    .check-card-toggle
    span {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  .check-card
    input[type="checkbox"]:checked
    ~ .check-card-body
    .check-card-toggle
    span:first-child {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  .check-card input[type="checkbox"]:checked ~ .check-card-bg {
    -webkit-transform: scale(25);
    transform: scale(25);
  }

  .bundle {
    .check-card-body-in {
      min-height: 250px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .check-card-title {
      font-size: 16px;
    }
    svg {
      margin-top: 10px;
    }
  }

  .badge {
    position: absolute;
    top: 10px;
    background: #34a853;
    box-shadow: 0px 6px 11px rgb(52 168 83 / 12%);
    border-radius: 30px 4px 4px 30px;
    line-height: 18px;
    right: -10px;
    font-weight: 800;
    font-size: 10px;
    text-transform: uppercase;
    span {
      background: #fff;
      color: #34a853;
      padding: 0px 2px;
      margin: 6px;
      font-size: 12px;
    }
  }
  .check-card-amount {
    font-family: "Bliss2", sans-serif;
    font-weight: 800;
    font-size: 1.3rem;
  }
  .check-card-sale-amount {
    font-family: "Bliss2", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
  }
  .ar {
    .badge {
      right: 0;
    }
    .check-card-amount {
      font-size: 1rem;
      .lato {
        font-size: 1.25rem;
      }
    }
  }
  .ar {
    .check-card-body {
      //  height: 220px !important;
    }
  }
  @media screen and (max-width: 767px) {
    .check-card {
      .check-card-item {
        .check-card-body {
          .check-card-body-in {
            padding: 25px 10px 20px;
          }
        }
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 991px) {
    .check-card {
      .check-card-item {
        .check-card-body {
          .check-card-body-in {
            padding: 25px 5px 20px;
            .check-card-title {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 992px) and (max-width: 1200px) {
    .check-card {
      .check-card-item {
        .check-card-body {
          .check-card-body-in {
            padding: 25px 10px 20px;
            display: flex;
            flex-direction: column;
            height: 320px;
            justify-content: space-between;
          }
        }
      }
    }
  }

  // @media screen and (max-width: 769px){
  //     .check-card .check-card-item .check-card-body .check-card-icon{
  //         width:25px;
  //         height:25px;
  //     }
  //     .check-card .check-card-item .check-card-body .check-card-title{
  //         font-size:11px;
  //     }

  //      .check-card .check-card-item .check-card-body .p-button{
  //         font-size: 11px;
  //         padding: 2px 10px !important;
  //         margin: 0;
  //     }
  // }

  @media only screen and (max-width: 576px) {
    .ar {
      .check-card-item .check-card-body .check-card-title {
        font-size: 16px;
      }
      .p-button.p-component {
        font-size: 14px;
      }
    }
  }

  .travel-platinum {
    border-radius: 20px;
    padding: 4px 14px;
    background: #742914;
    color: white;
    width: fit-content;
    margin: 0 auto;
    font-size: .8rem;
    line-height: 16px;
  }
  .platinum-active {
    background: #fff;
    color:  #6b47f5;
  }
`;

export default ProductCardWrapper;
